"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOfflineLink = exports.ErrorLink = void 0;
const apollo_link_1 = require("apollo-link");
const apollo_link_logger_1 = __importDefault(require("apollo-link-logger"));
const error_1 = __importDefault(require("./error"));
exports.ErrorLink = error_1.default;
const createOfflineLink = (_ref, offlineLink) => {
  let error = _ref.error,
    enableLogging = _ref.enableLogging;
  return apollo_link_1.ApolloLink.from([enableLogging ? apollo_link_logger_1.default : null, offlineLink, error ? (0, error_1.default)(error) : null].filter(Boolean));
};
exports.createOfflineLink = createOfflineLink;
exports.default = exports.createOfflineLink;